import { createStore, applyMiddleware,compose } from "redux";
import rootReducer from "./RootReducer";
import ReduxThunk from "redux-thunk"

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const Store =createStore(rootReducer,{},composeEnhancers(applyMiddleware(ReduxThunk)))

export default Store;
